export { Cards5 } from './translator';
